import { useContentOverflow } from '../../../hooks'
import { FloatingTooltip, FloatingTooltipContentText } from '../../Floating'
import Text from '../../Text'
import { TableEmptyCell } from '../TableCell'

import { QA_NAME_TABLE_CELL_TEXT } from './TableCellText.constants'

import * as styles from './TableCellText.module.css'

function TableCellText({
  AdditionalIcon,
  ArchivedIcon,
  BeforeIcon,
  additionalIconProps,
  additionalInfo,
  archivedIconProps,
  beforeIconProps,
  className = styles.TableCellText,
  floatingTooltipProps,
  ref,
  showTooltip = true,
  tooltip,
  value,
  ...textProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow({
    externalRef: ref,
  })

  return value ? (
    <div className={styles.textContainer}>
      {BeforeIcon ? <BeforeIcon {...beforeIconProps} /> : null}
      <FloatingTooltip
        {...floatingTooltipProps}
        content={
          <FloatingTooltipContentText
            additionalText={additionalInfo}
            text={tooltip || value}
          />
        }
        disabled={!showTooltip && !overflow}
      >
        <Text
          {...textProps}
          className={className}
          qaName={QA_NAME_TABLE_CELL_TEXT}
          ref={setContentOverflowRef}
        >
          {value}
        </Text>
      </FloatingTooltip>
      {ArchivedIcon ? <ArchivedIcon {...archivedIconProps} /> : null}
      {AdditionalIcon ? <AdditionalIcon {...additionalIconProps} /> : null}
    </div>
  ) : (
    <TableEmptyCell className={className} />
  )
}

export default TableCellText
